<div
  class="radio-group"
  [ngClass]="{ 'radio-group--inline': inline }"
  role="radiogroup"
  [attr.aria-labelledby]="id + '__label'"
>
  <ng-content></ng-content>
</div>
